export default __webpack_public_path__ + "static/media/location_preview_library.b804f93c.svg";